<div class="card">
  <div class="card-body">
    <div class="default-datepicker custom-datepicker">
      <div class="datepicker-here" data-language="en">
        <ngb-datepicker [(ngModel)]="model"></ngb-datepicker>
      </div>
    </div>
  </div>
</div>
